import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import pdfFile from '../images/sos.pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
};

class PDFView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            file: pdfFile,
            pageNumber: parseInt(this.props.pageNum)
        }
    }

    onFileChange = (event) => {
        this.setState({
            file: event.target.files[0],
        });
    }

    prevNextbtns(numPages) {
        let pageNumber = this.state.pageNumber;
        if (pageNumber <= 1) { // 2 > 1
            // prev false
            // next true
            this.setState({
                prvbtn: true,
                nxtbtn: false
            });
        } else if (numPages === pageNumber || numPages < pageNumber) {
            // prev true
            // next false
            this.setState({
                prvbtn: false,
                nxtbtn: true
            });
        } else {
            this.setState({
                prvbtn: false,
                nxtbtn: false
            });
        }
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.prevNextbtns(numPages);
        this.setState({ numPages });
    }

    goToPrevPage = () => {
        this.setState(state => ({ pageNumber: state.pageNumber - 1 }));
        this.prevNextbtns(this.state.numPages);
    }

    goToNextPage = () => {
        this.setState(state => ({ pageNumber: state.pageNumber + 1 }));
        this.prevNextbtns(this.state.numPages);
    }

    handleClose() {
        this.props.getResult();
    }

    render() {
        const { file, pageNumber, numPages } = this.state;
        return (
            <div>
                <div style={{ height: "378px", width: "100%", overflow: "auto" }}>
                    <Document
                        file={'./images/sos.pdf'}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        options={options}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                </div>
            </div >
        );
    }
}
export default PDFView;